































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, DatePicker, SwitchToggle } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

// models
import { HolidayForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'
import moment from 'moment'

// services
import { HolidayService } from '@/services/config'

const initItem: HolidayForm = {
    description: '',
    month: null,
    day: null,
    year: null,
    repeat_yearly: false,
    is_active: true,
    date: null
}

@Component({
    name: 'FormCreateEditHoliday',
    components: {
        Input,
        Radio,
        DatePicker,
        SwitchToggle
    },
    mixins: [validationMixin]
})
export default class FormCreateEditHoliday extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) holiday!: HolidayForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: HolidayForm = {
        description: '',
        month: null,
        day: null,
        year: null,
        repeat_yearly: false,
        is_active: true,
        date: null
    }

    created () {
        if (this.idEdit) {
            this.form = this.holiday
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                description: { required },
                date: { required },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        const date = moment(this.form.date)
        this.form.year = date.year()
        this.form.month = date.month() + 1
        this.form.day = date.date()

        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await HolidayService.update(this.idEdit, this.form)
                } else {
                    await HolidayService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = initItem
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
